import Guard from 'arg-guard'
// eslint-disable-next-line no-unused-vars
import Property from '@/models/property'

/**
 * A property with associated info objects.
 *
 * @export PropertyInfo
 * @class PropertyInfo
 */
export default class PropertyInfo {

    /**
     * Creates an instance of a RenovationOperationResult.
     * @param {Property} property Source property object.
     * @param {LinkedSchemeData} schemeInfo Linked scheme information.
     * @memberof PropertyInfo
     */
    constructor(property, schemeInfo = undefined) {
        Guard.throwIf(property, 'property')

        this.property = property
        this.schemeInfo = schemeInfo
    }
}
